import React from "react";
import { BillWatchLayout } from "../BillWatchLayout";
import { BillWatchEntities } from "../BillWatchEntities";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { BillWatchProps } from "../BillWatchProps";

interface RuleViewPageProps extends NSARouterMakerResult, BillWatchProps { }

class RuleViewPage extends React.Component<RuleViewPageProps>
{
	override render()
	{
		return (
			<BillWatchLayout
				{...this.props}
                action={{
                    description: "You can view a rule to see its details, general information, history, and effect on associated watches."
                }}
				pages={{
					entity: BillWatchEntities.rule(this.props),
					view: {}
				}}
			>
				<></>
			</BillWatchLayout>
		);
	}
}

export default RuleViewPage;